import { jsx, jsxs } from "react/jsx-runtime";
import { Field } from "@base-ui/react/field";
import { Input } from "@base-ui/react/input";
import { forwardRef } from "react";
import { CdnIcon } from "../CdnIcon/index.js";
import { Tooltip } from "../Tooltip/index.js";
const InputTextWrapper_InputTextWrapper = /*#__PURE__*/ forwardRef(function({ styles, iconLeft, ariaInvalid, errorText, maxLength, error, tooltipSideOffset = 0, errorMessage, success, iconRight, ...rest }, ref) {
    return /*#__PURE__*/ jsxs("div", {
        className: styles.inputWrapper(),
        children: [
            iconLeft ? /*#__PURE__*/ jsx("div", {
                className: styles.iconLeft(),
                children: /*#__PURE__*/ jsx(CdnIcon, {
                    iconName: iconLeft,
                    size: "24"
                })
            }) : null,
            /*#__PURE__*/ jsx(Input, {
                "aria-invalid": ariaInvalid || !!errorText,
                className: styles.input(),
                maxLength: maxLength,
                ref: ref,
                ...rest
            }),
            /*#__PURE__*/ jsx(Field.Error, {
                match: error,
                className: styles.errorTextSlot(),
                children: /*#__PURE__*/ jsx(Tooltip, {
                    defaultOpen: true,
                    open: error,
                    emphasis: true,
                    sideOffset: tooltipSideOffset,
                    closeDelay: 90000,
                    color: "error",
                    align: "end",
                    side: "bottom",
                    triggerNode: /*#__PURE__*/ jsx(CdnIcon, {
                        iconName: "error",
                        size: "20"
                    }),
                    children: /*#__PURE__*/ jsx("div", {
                        "aria-live": "assertive",
                        children: errorMessage
                    })
                })
            }),
            success ? /*#__PURE__*/ jsx("div", {
                className: styles.successTextSlot(),
                children: /*#__PURE__*/ jsx(CdnIcon, {
                    palette: "success",
                    iconName: "task_alt"
                })
            }) : null,
            iconRight ? /*#__PURE__*/ jsx("div", {
                className: styles.iconRight(),
                children: /*#__PURE__*/ jsx(CdnIcon, {
                    iconName: iconRight,
                    size: "20"
                })
            }) : null
        ]
    });
});
export { InputTextWrapper_InputTextWrapper as InputTextWrapper };
